import { Vehicle } from "@tm/models"
import { QueryClient } from "react-query"
import { saveVehicle } from "./saveVehicle"
import { loadVehicle } from "./loadVehicle"

/**
 * @deprecated Use `saveVehicle()` instead.
 * */
export async function updateVehicle(vehicle: Vehicle, queryClient: QueryClient): Promise<Vehicle> {
    const { id, mileAge, vin, plateId, initialRegistration, engineCode, retailPurchasePrice, retailSalesPrice } = vehicle

    const storedVehicle = await loadVehicle(id)

    return saveVehicle(
        {
            ...storedVehicle,
            mileAge,
            vin,
            plateId,
            initialRegistration,
            engineCode,
            retailPurchasePrice,
            retailSalesPrice,
        },
        queryClient
    )
}
